import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TypographyModule } from 'hig-ng-lib';
import { TimePickerComponent } from './time-picker.component';

@NgModule({
    declarations: [TimePickerComponent],
    imports: [CommonModule, ReactiveFormsModule, TypographyModule, FormsModule],
    exports: [TimePickerComponent]
})
export class TimePickerModule {}
